import { useEffect } from 'react'
import { useNavigate } from 'react-router-dom'

const Redirect = ({ pathname }) => {
  const navigate = useNavigate()

  useEffect(() => {
    pathname && navigate(pathname)
  }, [history, pathname])

  return <></>
}

export default Redirect
